<template>
    <div class="cxecrt-cart-form cxecrt-send-cart-email-form" :class="{loader: $store.getters.loading}">
        <template v-if="!hasShared">
            <template v-if="!isAdmin || showFormForAdmin">
                <div class="modal-desc">
                    {{ share_cart.popup_description }}
                </div>
                <notifications
                    :target="'share_cart'"
                />

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-row-to-address" :class="{error: errors.to}">
                        <div v-if="errors.to" class="cxecrt-row-error" v-html="errors.to"></div>
                        <input
                            disabled
                            class="cxecrt-input-text"
                            type="text"
                            placeholder="To email address(es), comma separated"
                            v-model="share_cart.to"
                        />
                        <label>To*</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-row-to-address"  :class="{error: errors.cc}">
                        <div v-if="errors.cc" class="cxecrt-row-error" v-html="errors.cc"></div>
                        <input class="cxecrt-input-text" type="text" placeholder="To email address(es), comma separated"
                               v-model="share_cart.cc">
                        <label>CC</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-row-from-address"  :class="{error: errors.from}">
                        <div v-if="errors.from" class="cxecrt-row-error" v-html="errors.from"></div>
                        <input class="cxecrt-input-text" type="text" v-model="share_cart.from" placeholder="Your Email Address">
                        <label>From*</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-phone"  :class="{error: errors.phone}">
                        <div v-if="errors.phone" class="cxecrt-row-error" v-html="errors.phone"></div>
                        <input class="cxecrt-input-text" type="text"
                        v-on:input=" share_cart.phone = phoneInputFormatter($event)"
                        @keypress="numbersOnly"
                        maxlength="14"
                        v-model="share_cart.phone" placeholder="Phone number">
                        <label>PHONE</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-shipping-zip" :class="{error: errors.zipcode}">
                        <div v-if="errors.zipcode" class="cxecrt-row-error" v-html="errors.zipcode"></div>
                        <input class="cxecrt-input-text" type="text" v-model="share_cart.zipcode" placeholder="Shipping ZIP">
                        <label>SHIPPING ZIP*</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-shipping-state" :class="{error: errors.state}">
                        <div v-if="errors.state" class="cxecrt-row-error" v-html="errors.state"></div>
                        <select
                            class="cxecrt-input-text"
                            v-model="share_cart.state"
                        >
                            <option v-for="item in constants.STATE_LIST" :value="item.label">{{ item.label }}</option>
                        </select>
                        <label>State*</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-row-from-name" :class="{error: errors.fromName}">
                        <div v-if="errors.fromName" class="cxecrt-row-error" v-html="errors.fromName"></div>
                        <input class="cxecrt-input-text text-capitalize"  autocapitalize="words" type="text" v-model="share_cart.fromName" placeholder="Your Name"
                        v-on:focusout="share_cart.fromName = capitalizeWords($event)">
                        <label>From Name*</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field" :class="{error: errors.subject}">
                        <div v-if="errors.subject" class="cxecrt-row-error" v-html="errors.subject"></div>
                        <input class="cxecrt-input-text disabled" v-model="share_cart.subject" type="text" placeholder="Your subject" value="Please Review My Cart" disabled>
                        <label>Subject</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field" :class="{error: errors.description}">
                        <div v-if="errors.description" class="cxecrt-row-error" v-html="errors.description"></div>
                        <textarea v-model="share_cart.description" rows="18" cols="20"
                                  placeholder="Please describe what you would like us to review in your Cart"></textarea>
                        <label class="cxecrt-email-content-label">DESCRIPTION*</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <a class="tn_pink_btn" v-on:click="shareCart">Share Cart <i class="cxecrt-icon-export"></i></a>
                </div>
            </template>
            <template v-if="isAdmin && !showFormForAdmin">
                <notifications
                    :target="'share_cart'"
                />

                <div class="cxecrt-row">
                    <div class="cxecrt-row-field cxecrt-row-to-address" :class="{error: errors.redirectTo}">
                        <div v-if="errors.redirectTo" class="cxecrt-row-error" v-html="errors.redirectTo"></div>
                        <select
                            class="cxecrt-input-text"
                            v-model="share_cart.redirectTo"
                        >
                            <option value="cart">Cart Page</option>
                            <option value="checkout">Checkout Page</option>
                        </select>
                        <label>Redirect To</label>
                    </div>
                </div>

                <div class="cxecrt-row">
                    <a class="tn_pink_btn" v-on:click="shareCartAndGenerateLink">Share Cart & Generate Link <i class="cxecrt-icon-basket"></i></a>
                </div>
            </template>
        </template>
        <div v-if="hasShared && (!isAdmin || showFormForAdmin)" class="cxecrt-sent-notification text-center">
            <p>Your Cart Has Been Successfully Shared!</p>
        </div>
        <div v-if="hasShared && isAdmin && !showFormForAdmin" class="share-admin-text">
            <div class="modal-desc">
                Click the "Save Cart & Generate Link" button below. Then copy and paste the link into an email to yourself and/or others to retrieve it at any time during the next ninety (90) days.
            </div>
            <input class="cxecrt-input-text" type="text" v-model="generatedUrl">
            <div class="cxecrt-row cxecrt-double-buttons">
                <a class="cxecrt-button" v-on:click="showFormForAdmin = true; hasShared = false">Send Cart in an Email</a>
                <a class="cxecrt-button" v-on:click="closeModal">Done! close</a>
            </div>
        </div>

    </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from "vuex";
import Notifications from "./Notifications";

export default {
    name: 'save-cart-modal-body',
    components: {Notifications},
    data() {
        return {
            hasShared: false,
            generatedUrl: null,
            showFormForAdmin: false,
            cartId: null
        }
    },
    computed: {
        ...mapState(['share_cart']),
        ...mapGetters(['isAdmin']),
        errors() {
            return this.$store.getters.validationErrors
        },
    },
    methods: {
        ...mapActions(['saveAndShare', 'saveAndGenerateLink','calcGroundFreight','beforeCalcGroundFreight']),
        shareCart() {
            this.saveAndShare(this.cartId).then(([error, data]) => {
                if(!error) {
                    this.hasShared = true
                }
            })
        },
        numbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        phoneInputFormatter($event) {

            let value = $event.target.value.replace(' ', '')

            if (!value.length ) {
                return ''
            }

            // if (value.includes('(') || value.includes(')') || value.includes('-')) {
            //     value = value.replace('(', '').replace(')', '').replace('-', '')
            // }
            value= value.replace(/[^0-9]/g,"");
            if(value.length >10)
            {
                value = value.slice(0,10);
            }

            let phoneCode = value.length > 3 ? '(' + value.slice(0, 3) + ')' : ''
            let phoneNumber = '', phoneFirstPart = '', phoneLastPart = ''
            if (phoneCode.length) {
                phoneNumber = value.slice(3)
                phoneFirstPart = ' ' + phoneNumber.slice(0, 3)

                if (phoneFirstPart.trim().length && phoneFirstPart.trim().length >= 3) {
                    phoneLastPart = phoneNumber.replace(phoneFirstPart.trim(), '')
                    phoneLastPart = phoneLastPart.length ? '-' + phoneLastPart : ''
                }
                value = `${phoneCode}${phoneFirstPart}${phoneLastPart}`
            }
            return value;
        },
        capitalizeWords($event) {
            var words = $event.target.value.split(" ");
            for (var i = 0; i < words.length; i++) {
                var word = words[i];
                words[i] = word.charAt(0).toUpperCase() + word.slice(1);
            }
            return words.join(" ");
        },
        shareCartAndGenerateLink() {
            this.saveAndGenerateLink().then(([error, data]) => {
                if(!error) {
                    this.hasShared = true
                    this.generatedUrl = data.generatedUrl
                    this.cartId = data.cartId
                }
            })
        },
        closeModal() {
            document.querySelector('#shareCartModal .close').click();
            this.beforeCalcGroundFreight();
        }
    }
}
</script>
<style scoped>
.cxecrt-sent-notification {
    background: #FFF7DB;
    padding: 15px 30px;
    font-size: 14px;
    color: rgba(165, 108, 66, 0.76);
    border: 1px solid rgba(142, 77, 29, 0.12);
    border-radius: 3px;
    font-weight: bold;
}
.share-admin-text  .modal-desc {
    max-width: 410px;
    padding: 6px 15px 22px;
    width: 100%;
    margin: 0 auto;
}
.share-admin-text .cxecrt-input-text {
    padding: 9px 23px 9px 9px;
    background: #4c4c4c;
    border-radius: 3px;
    margin-bottom: 12px;
    font-size: 14px;
    border: 0;
    text-align: left;
    min-height: 40px;
    width: 100%;
    color: #fff;
}
.share-admin-text .cxecrt-double-buttons {
    height: 35px;
    padding: 0;
}
.share-admin-text .cxecrt-double-buttons a:last-child { right: 0; }
.share-admin-text .cxecrt-double-buttons a:first-child { left: 0; }
.share-admin-text .cxecrt-double-buttons a {
    border-radius: 3px;
    position: absolute;
    width: 49%;
    text-align: center;
    background: #96588a;
    padding: 9px 15px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
    line-height: 22px;
    text-shadow: 0 1px 0 rgb(0 0 0 / 10%);
}

</style>
